import Component from '@glimmer/component';

interface LayoutModalIconWrapperSignature {
  Element: HTMLDivElement;
  Blocks: {
    default: [];
  };
}

export default class LayoutModalIconWrapperComponent extends Component<LayoutModalIconWrapperSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Layout::Modal::IconWrapper': typeof LayoutModalIconWrapperComponent;
    'layout/modal/icon-wrapper': typeof LayoutModalIconWrapperComponent;
  }
}
